import sortBy from 'lodash/sortBy';
import { ApolloClient, Reference } from '@apollo/client';

import { SlideshowSlide } from './slideshow.constants';
import { LANGUAGE_CODE_EN_AU } from 'global/constants';

export function sortSlides(slideshowImages: SlideshowSlide[]) {
  return sortBy(slideshowImages, 'sort');
}

export function addImageToSlideshow({
  client,
  slideshowComponentId,
  componentId,
}: {
  client: ApolloClient<any>;
  slideshowComponentId: string;
  componentId: string;
}) {
  client.cache.modify({
    id: client.cache.identify({
      id: slideshowComponentId,
      __typename: 'ActivitiesSlideshowComponent',
      language: LANGUAGE_CODE_EN_AU,
    }),
    fields: {
      slideshowImages(existingImageRefs: Reference[]) {
        return [
          ...existingImageRefs,
          {
            __ref: client.cache.identify({
              id: componentId,
              __typename: 'ActivitiesImageComponent',
              language: LANGUAGE_CODE_EN_AU,
            }),
          },
        ];
      },
    },
  });
}

export function removeImageFromSlideShowInCache({
  client,
  slideshowComponentId,
  imageComponentId,
}: {
  client: ApolloClient<any>;
  slideshowComponentId: string;
  imageComponentId: string;
}) {
  client.cache.modify({
    id: client.cache.identify({
      id: slideshowComponentId,
      __typename: 'ActivitiesSlideshowComponent',
      language: LANGUAGE_CODE_EN_AU,
    }),
    fields: {
      slideshowImages: (existing: Reference[], { readField }) => {
        return existing.filter(ref => {
          return readField('id', ref) !== imageComponentId;
        });
      },
    },
  });
}
